<div class="relative w-[25rem] lg:w-screen max-w-[80vw] lg:max-w-[35vw] px-6 py-3 rounded-3xl shadow-sm bg-white">
  <!-- Floating Label -->
  <label
    for="input"
    [class.text-gray-400]="!value && !isFocused"
    [class.text-xs]="value || isFocused"
    [class.text-gray-500]="value || isFocused"
    [class.-translate-y-3]="value || isFocused"
    class="absolute left-6 top-4 transition-all text-xl pointer-events-none"
  >
    {{ label }}
  </label>

  <!-- Input Field -->
  <input
    id="input"
    type="text"
    [(ngModel)]="value"
    (ngModelChange)="onInputChange($event)"
    (focus)="isFocused = true"
    (blur)="isFocused = value !== ''"
    [placeholder]="isFocused ? '' : placeholder"
    [pattern]="pattern"
    [maxlength]="maxLength"
    class="block w-full bg-white px-4 mt-4 text-gray-900 placeholder-transparent rounded-lg focus:outline-none text-xl"
  />

  <!-- Error Message -->
</div>

<div *ngIf="startValidate && !isValid()" class="text-red-500 text-base mt-2 ml-5">
{{ errorMessage }}
</div>